import styled from 'styled-components';

export const OptionRenderContainer = styled.div`
    display: flex;
    gap: 8px;
    height: 100%;
`;

export const SeverityColor = styled.div`
    height: 100%;
    width: 8px;
    border-radius: 6px;
`;